import { __read } from "tslib";
export function isHydrated(_a) {
    var _b = __read(_a, 2), value = _b[1];
    return !!value;
}
//# sourceMappingURL=data-pointer.js.map